export const environment = {
  production: false,
  gatewayUrl:'https://api.uplift-plus-dev.riotinto-dna.com',
  cognitoDomain: 'uplift-plus-dev.auth.ca-central-1.amazoncognito.com',
  cognitoRedirectIn: 'https://uplift-plus-dev.riotinto-dna.com/',
  cognitioRedirectOut: 'https://uplift-plus-dev.riotinto-dna.com/',
  cognitoUserPoolId: 'ca-central-1_cP92J61VS',
  cognitoUserPoolWebClientId: '6lomuu9oet8avkahfe8jbaql5s',
  cognitoIdentityPoolId: 'ca-central-1:95a3a76a-24cd-432c-9eb2-76a5ae6d0c34',
  cognitoAwsRegion: 'ca-central-1',
};
